/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsBRLYtabs = {
    init: function () {
      var $ = window.jQuery;
      if (typeof $ !== "function") {
        console.error("jQuery unavailable for BRLY tabs.");
        return;
      }

      let $tabs = $(".brlytabs li, .brlytabs li a");

      $tabs.on("click", function (el) {
        el.preventDefault();

        // toggle active tab
        $tabs.removeClass("is-active active");
        $(this).addClass("is-active");

        let $tabIndex = $(this).index();
        let $tabContent = $(this)
          .parents(".brlytabs")
          .next(".brlytabs-content");

        // toggle corresponding tab content
        $tabContent.children("li, li a").removeClass("is-active active");
        $tabContent
          .children("li, li a")
          .eq($tabIndex)
          .addClass("is-active")
          .show()
          .css({ display: "block" })
          .siblings()
          .hide()
          .removeClass("is-active");
      });


      function getFullReviewsWidget() {
        var fullWidgets = document.querySelectorAll("[data-product-reviews-full], #product-reviews.product-reviews-widget--apps");
        if (fullWidgets.length) {
          return fullWidgets[fullWidgets.length - 1];
        }

        var reviewNodes = document.querySelectorAll("#product-reviews");
        for (var index = reviewNodes.length - 1; index >= 0; index -= 1) {
          if (!reviewNodes[index].closest("[data-product-reviews-carousel], .product-reviews-carousel")) {
            return reviewNodes[index];
          }
        }

        return null;
      }

      function getProductReviewsTarget() {
        var fullReviewsWidget = getFullReviewsWidget();
        var customerReviewsHeading = Array.from(document.querySelectorAll("h2.title, h2")).find(function(heading) {
          return /^customer reviews$/i.test(heading.textContent.trim());
        });

        if (customerReviewsHeading) {
          var headingSection = customerReviewsHeading.closest(".shopify-section");
          if (headingSection) {
            if (!fullReviewsWidget || (headingSection.compareDocumentPosition(fullReviewsWidget) & Node.DOCUMENT_POSITION_FOLLOWING)) {
              return headingSection;
            }
          }
          return customerReviewsHeading;
        }

        if (fullReviewsWidget) {
          return fullReviewsWidget.closest(".shopify-section") || fullReviewsWidget;
        }

        return null;
      }

      function performReviewsScroll() {
        var reviewsTarget = getProductReviewsTarget();
        if (!reviewsTarget) {
          return false;
        }

        var scrollOffset = typeof Shopify !== "undefined"
          && Shopify.theme
          && typeof Shopify.theme.getAnchorScrollOffset === "function"
          ? Shopify.theme.getAnchorScrollOffset()
          : 160;
        var top = reviewsTarget.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: "smooth"
        });
        return true;
      }

      function scrollToProductReviews(event) {
        if (event) {
          event.preventDefault();
          if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
          }
        }

        var attempts = 0;
        var maxAttempts = 40;

        function tryScroll() {
          if (performReviewsScroll()) {
            window.setTimeout(performReviewsScroll, 300);
            return;
          }

          attempts += 1;
          if (attempts < maxAttempts) {
            window.setTimeout(tryScroll, 100);
          }
        }

        tryScroll();
      }

      $(document).on(
        "click",
        ".open-reviews-tab, .yotpo-widget-instance, .yotpo-sr-bottom-line-summary, .yotpo-sr-bottom-line-button, .open-reviews-tab .yotpo-stars, .open-reviews-tab .text-m, .open-reviews-tab a, .yotpo-widget-instance a, .yotpo-widget-instance button, .yotpo-sr-bottom-line-summary *, .yotpo-sr-bottom-line-button *",
        function (el) {
          if ($(el.target).closest("#product-reviews, [data-product-reviews-full], .product-reviews-widget, [data-product-reviews-carousel], .product-reviews-carousel").length) {
            return;
          }
          scrollToProductReviews(el);
        }
      );
      
    },
    unload: function () {
      $(".brlytabs li, .brlytabs li a").off();
    },
  };
  /******/
})();
